// auth.js

import { useAuthStore } from '@/stores/authStore';

// Logica per verificare se l'utente è loggato
export async function isLoggedIn(): Promise<boolean> {

	const authStore = useAuthStore();
	// richiamo i dati dell'utente, ogni volta
	await authStore.fetchUser();
	// se i dati sono presenti, l'utente è "loggato"
	return authStore.isLoggedIn;
}
